<template>
  <div>
    <div class="servicePopup">
      <div
        v-for="{ id, avatar, name, account, type } in ServicoList"
        :key="id"
        class="popItem"
      >
        <div class="flex">
          <div class="flex-center-x w-16">
            <Image class="size-9 rounded-4 mr-2" :src="avatar" alt="telegram" />
          </div>
          <div>
            <span class="name">{{ name }}</span>

            <div class="flex h-8 text-12 pt-1">
              <span v-if="type !== 'OnlineCS'" class="truncate max-w-44 mr-1">{{
                type
              }}</span>
              <span class="truncate max-w-44" @click="copy(type, account)">
                {{ account }}
              </span>
            </div>
            <van-button class="chat" @click="openLink(type, account)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { copyText } from "@/utils";
import { useServico } from "@/store";

// 客服列表
const ServicoList = computed(() => useServico().list);

// 获取最新客服列表
useServico().init();

const copy = (type: string, account: string) => {
  switch (type) {
    case "Tel":
      copyText(account);
      break;
    case "Whatsapp":
      copyText(`https://wa.me/${account}`);
      break;
    case "Instagram":
      copyText(`https://instagram.com/${account}`);
      break;
    case "Telegram":
      copyText(`https://t.me/${account}`);
      break;
    default:
      copyText(account);
      break;
  }
};

const openLink = (type: string, account: string) => {
  switch (type) {
    case "Tel":
      window.location.href = `tel:${account}`;
      break;
    case "Whatsapp":
      window.open(`https://wa.me/${account}`, "_blank");
      break;
    case "Instagram":
      window.open(`https://instagram.com/${account}`, "_blank");
      break;
    case "Telegram":
      window.open(`https://t.me/${account}`, "_blank");
      break;
    default:
      window.open(account, "_blank");
  }
};
</script>

<style scoped lang="scss">
.servicePopup {
  padding: 16px;
  padding-top: 20px;
  overflow: scroll;
  height: 100%;

  .popItem {
    width: 343px;
    height: 116px;
    padding-top: 14px;
    background: url(@a/assets/images/bg1b.png) no-repeat 0 0 / 343px 116px;
    margin: 0 auto 16px;
    color: var(--theme-secondary);

    @for $i from 2 through 4 {
      &:nth-child(4n + #{$i}) {
        background-image: url(@a/assets/images/bg#{$i}b.png);
      }
    }

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 110px;
      font-size: 15px;
      line-height: 22px;
      font-weight: bold;
    }

    .chat {
      width: 94px;
      height: 34px;
      background: url(@a/assets/images/i_chat.png) no-repeat 0 0 / cover;
      border: none;
    }
  }
}
</style>
